import React, { useEffect, useState } from "react";
import { SecureDocModel } from "../../models/secure-docs.model";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors'
import StepperUpload from "./stepper-upload.component";
import { useSearchParams } from "react-router-dom";

interface IProps {
}

const FalkonDocsUploads = (props: IProps) => {
    const [searchParams] = useSearchParams();
    const isUpdateMode = searchParams.get("update") === "true";
    const fileID = searchParams.get("fileId");
    const SecureDocs: SecureDocModel[] = useSelector(selector.secureDocs)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)

    return (
       <React.Fragment>
			<div className={`p-2 ${IsTeamsApp ? "o-y-scroll" : ""}`}>
				<StepperUpload
					secureDocsData={SecureDocs}
					isTeams={IsTeamsApp}
                    isUpdateMode={isUpdateMode}
                    fileID={fileID}
				/>
			</div>
		</React.Fragment >
    );

}

export default FalkonDocsUploads;